module.exports = __webpack_public_path__ + "img/Topic-technology.924f6e2e.svg";